import React from 'react';
import { useSpecSheetField } from '../../../../../queries/useSpecSheetField';
import { TextBox } from '@apply/components';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';

interface WallsProps {
    readOnly?: boolean;
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const Walls: React.FC<WallsProps> = ({ required, readOnly, propertyGuid, isReview = false }) => {
    const [walls, setWalls] = useSpecSheetField(
        propertyGuid,
        (s) => s.values?.['Interior Features']?.['Walls'] ?? '',
        (s, v) => ({ ...s, values: { ...s.values, 'Interior Features': { ...s.values?.['Interior Features'], Walls: v } } })
    );
    const label = 'Walls';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={walls}
                />
            ) : (
                <TextBox
                    value={walls ?? ''}
                    onChange={(value) => setWalls(value)}
                    label={label}
                    required={required}
                    readOnly={readOnly}
                />
            )}
        </>
    );
};
